var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8432 15.8176L11.3579 22.5184C12.0522 22.5184 12.3528 22.2256 12.7134 21.874L15.9683 18.82L22.7126 23.6692C23.9496 24.346 24.821 23.9896 25.1547 22.552L29.5817 2.18568L29.5829 2.18448C29.9753 0.389285 28.9217 -0.312712 27.7165 0.127686L1.69481 9.90884C-0.081118 10.5856 -0.0542285 11.5576 1.39292 11.998L8.04563 14.0296L23.4986 4.53646C24.2258 4.06367 24.887 4.32526 24.3431 4.79806L11.8432 15.8176Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic_telegram.9a83f691e9a4187844c973a02691e23e.svg";
export { ForwardRef as ReactComponent };